export default function useImage() {
  return {
    convertToBlob: async (image) => {
      if (!image) {
        console.error("No image to upload")
        return
      }

      const base64Data = image.split(',')[1]
      const contentType = image.split(';')[0].split(':')[1]
  
      const byteCharacters = atob(base64Data)
      const byteArrays = []
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i))
      }
      const byteArray = new Uint8Array(byteArrays)
      const blob = new Blob([byteArray], { type: contentType })

      return {blob, contentType}
    }
  }
}